<template>
  <div id="login">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Login</h1>
          <div class="column is-half" ref="form">
            <section>
              <b-field label="User">
                <b-input
                  v-model="input.username"
                  required
                  validation-message="Scrivi qualcosa!"
                ></b-input>
              </b-field>

              <b-field label="Password">
                <b-input
                  v-model="input.password"
                  type="password"
                  required
                  validation-message="Scrivi qualcosa!"
                ></b-input>
              </b-field>
            </section>
            <section>
              <div class="buttons">
                <b-button @click="login()" type="is-primary">Ok!</b-button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import api from "../api/api.js";
import helpers from "../helpers.js";

export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      api.login(this.input.username, this.input.password)
      .then((data)=>{
        let token =data.data;
        let user = {username: this.input.username, token}
         localStorage.setItem("user", JSON.stringify(user));
         this.$router.replace({ name: "Vision" });
      }) 
      .catch(()=> {
        helpers.error("Oooops!");
      })
    },
  },
};
</script>